export default "__VITE_ASSET__DfWr3RzL__"